import { Box, Stack, Typography } from "@mui/material";
import axios from "axios";
import { TextField } from "formik-mui";
import { useEffect, useState } from "react";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { Config } from "../../utils/commonFuctions/Token";
import { base_url } from "../backendurl/url";
import CardComponent from "./CardComponent";
import dash1 from "../../images/dash1.png";
import dash2 from "../../images/dash2.png";
import dash3 from "../../images/dash3.png";
import dash4 from "../../images/dash4.png";
import dash5 from "../../images/dash5.png";
import dash6 from "../../images/dash6.png";
import Linechart from "./Linechart";
import Barchart from "./Barchart";
import CustomLineChart from "./Linechart";
import { ObjectSchema } from "yup";
import CustomPieChart from "./CustomPieChart";
import { currencyformater } from "../common/TransForm/currencyformater";
import { Notification } from "../common/Notification";
import TokenTransferChart from "./TokenTransferChart";
import { getColorsForChartData } from "../../utils/codeGenerator";

export default function Dashboard() {
  const [dashborad, setdashborad] = useState();
  const [CashflowData, setCashflowData] = useState([]);
  const [dat, setDat] = useState();
  const [leagues, setleagues] = useState([]);
  const [roundChart, setroundChart] = useState([]);
  const [userChart, setuserChart] = useState([]);
  const [PlayerTop, setPlayerTop] = useState([]);
  const [NonActive, setNonActive] = useState();
  const [leagueFilter, setLeagueFilter] = useState([]);
  const [LocationStatus, setLocationStatus] = useState([]);
  const [notification, setnotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  // Add this state in your Dashboard component
const [tokenTransferData, setTokenTransferData] = useState([]);
// Add these state variables to your existing Dashboard component (add these after your existing state declarations)
const [preferredLeaguesData, setPreferredLeaguesData] = useState([]);

const [preferredGamesData, setPreferredGamesData] = useState([]);
const [accessLocationData, setAccessLocationData] = useState([]);
console.log(accessLocationData, "accessLocationData")
const [selectedLeagueFilter, setSelectedLeagueFilter] = useState("All")

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  

  const [filterData, setfilterData] = useState({
    Cashflow: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(), //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    location: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(),  //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    user: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(), //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    leagues: [],
    rounds: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(),  //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    top_players: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(), //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    non_active: [
      {
        startDate:  new Date(new Date().setDate(new Date().getDate() -30)) ,
        endDate:new Date(),  //addDays(new Date(), 7),
        key: "selection",
        range: null,
      },
    ],
    Cashflow: [
    {
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
      key: "selection",
      range: null,
    },
  ],
    token_transfer: [
    {
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
      key: "selection",
      range: null,
    },
  ],
  access_location: [
  {
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date(),
    key: "selection",
    range: null,
  },
],
  });


  const getDashboradData = async () => {
    try {
      
      const dashboard = await axios.get(
        `${base_url}/api/dashboard/admin-dashboard/summary`,
        Config
      );
      if (dashboard.status == 200) {
        setdashborad(dashboard?.data?.data);
        // setuserChart([
        //   {
        //     name: "Active Users",
        //     value: dashboard?.data?.data?.active_users,
        //     color: "#0FADCF",
        //   },
        //   {
        //     name: "Non-Active Users",
        //     value: dashboard?.data?.data?.in_active,
        //     color: "#3C50E0",
        //   },
        // ]);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification)  
    }
  };

  const getLeaguesData = async () => {
    try {
      const leaguedata = await axios.get(`${base_url}/api/pot/seasons`, Config);
      if (leaguedata.status == 200) {
        const leagueList = leaguedata.data.data.map((item) => {
          return { name: item.display_name, value: item.league_season_id };
        });
        setLeagueFilter(leagueList);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };

  const getUserManagement = async (url, filter) => {
    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }

      const userEngagement = await axios.get(url, Config);
      if (userEngagement.status == 200) {
        setuserChart([
          {
            name: "Active Users",
            value: userEngagement?.data?.data?.active,
            color: "#0FADCF",
          },
          {
            name: "Non-Active Users",
            value: userEngagement?.data?.data?.inactive,
            color: "#3C50E0",
          },
        ]);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };

  const getPopularLeagues = async (url, filter) => {
    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }

      const PopularLeagues = await axios.get(url, Config);
      if (PopularLeagues.status == 200) {
        setleagues(PopularLeagues?.data?.data?.league_players);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };

  const getPlayerDetails = async (url, filter) => {

    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }

      const topPlayer = await axios.get(url, Config);
      if (topPlayer.status == 200) {
        setPlayerTop(topPlayer?.data?.data?.top_players);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };

  const getNonActivePlayerDetails = async (url, filter) => {
    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }

      const nonPlayer = await axios.get(url, Config);
      if (nonPlayer.status == 200) {
        setNonActive(nonPlayer?.data?.data?.inactive);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };
  const getCashFlow = async (url, filter) => {
    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }
      const cashFlow = await axios.get(url, Config);

      if (cashFlow.status == 200) {
        const allDates = new Set([
          ...cashFlow?.data?.data?.commisions.map((item) => item.date),
          ...cashFlow?.data?.data?.payouts.map((item) => item.date),
          ...cashFlow?.data?.data?.contributions.map((item) => item.date),
        ]);

        const sortedDates = Array.from(allDates).sort();
        const combinedData = Array.from(sortedDates).map((date) => {
          const commisionsItem = cashFlow?.data?.data?.commisions.find(
            (item) => item.date === date
          );
          const payoutsItem = cashFlow?.data?.data?.payouts.find(
            (item) => item.date === date
          );
          const contributionsItem = cashFlow?.data?.data?.contributions.find(
            (item) => item.date === date
          );

          return {
            date,
            commisions: commisionsItem ? commisionsItem.value : 0,
            payouts: payoutsItem ? payoutsItem.value : 0,
            contributions: contributionsItem ? contributionsItem.value : 0,
          };
        });

        setCashflowData(
          combinedData
          // {
          //   commisions: {
          //     name: "Admin Fee",
          //     color: "#80CAEE",
          //     data: cashFlow?.data?.data?.commisions,
          //   },
          //   payouts: {
          //     name: "Total Payouts",
          //     color: "#0FADCF",
          //     data: cashFlow?.data?.data?.payouts,
          //   },
          //   contributions: {
          //     name: "Total Contributions",
          //     color: "#3C50E0",
          //     data: cashFlow?.data?.data.contributions,
          //   },
          // }
        );
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error data:", error?.response?.request?.status);
    }
  };

  const getLocationStatus = async (url, filter) => {
    try {
      if (filter) {
        url =
          url +
          `?end=${formatDate(filter[0].endDate)}&start=${formatDate(
            filter[0].startDate
          )}`;
      }
      const Location = await axios.get(url, Config);
      if (Location.status == 200) {
        setLocationStatus(Location?.data?.data);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error data:", error?.response?.request?.status);
    }
  };
  const getLeagues = async (url, filter) => {
    try {
      if (filter) {
        url = url + `?league=${filter}`;
      }
      const leagues = await axios.get(url, Config);

      if (leagues.status == 200) {
        let response = leagues?.data?.data;
        setroundChart([
          {
            name: "Active Round",
            value: response?.active_pots,
            color: "#3C50E0",
          },
          {
            name: "Prize Poll/Jackpot Round",
            value: response?.jack_pots,
            color: "#6E80FF",
          },
          {
            name: "Waitlist Round",
            value: response?.waitlist_pots,
            color: "#80CAEE",
          },
          {
            name: "Completed Round",
            value: response?.completed_pots,
            color: "#0FADCF",
          },
        ]);
      }
    } catch (error) {
      RefreshToken(error,setErrorMessage,setnotification) 
      console.error("Error fetching data:", error);
    }
  };

  console.log(tokenTransferData, "tokenTransferData")
//NewChart Function Start
  // Add this function to fetch token transfer data
const getTokenTransferData = async (url, filter) => {
  try {
    if (filter) {
      url = url + `?end=${formatDate(filter[0].endDate)}&start=${formatDate(filter[0].startDate)}`;
    }

    const response = await axios.get(url, Config);
    console.log(response, "getTokenTransferDataresponse")
    if (response.status == 200) {
      const transformedData = response.data.data.map(item => ({
        name: item.label,  // Using 'label' from API as 'name' for chart
        value: item.value  // Using 'value' from API
      }));
      setTokenTransferData(transformedData);
      // Process your API response here
      // For now, using dummy data structure
      // setTokenTransferData([
      //   { period: '1 Month', transfers: 200, amount: 15000 },
      //   { period: '3 Month', transfers: 120, amount: 8000 },
      //   { period: '6 Month', transfers: 190, amount: 12000 },
      //   { period: 'Over 1 Years', transfers: 50, amount: 3000 }
      // ]);
    }
  } catch (error) {
    RefreshToken(error, setErrorMessage, setnotification);
    console.error("Error fetching token transfer data:", error);
  }
};

// Dummy functions for the new charts (add these after your existing functions)
const getDummyPreferredLeagues = () => {
  // This will be replaced with actual API call later
  console.log("Getting preferred leagues data");
};

const getDummyPreferredGames = () => {
  // This will be replaced with actual API call later
  console.log("Getting preferred games data");
};

// Function to fetch preferred games data
const getPreferredGamesData = async () => {
  try {
    const response = await axios.get(`${base_url}/api/dashboard/admin-dashboard/games/`, Config);
    if (response.status === 200) {
      const gamesData = response.data?.data?.games;
      console.log(gamesData, "gamesData")
      
      // Transform the API response to match your chart format
      const transformedData = gamesData.map((game, index) => {
        // Define colors for different games
        const colors = ["#3C50E0", "#6E80FF", "#80CAEE", "#0FADCF", "#FF6B6B", "#4ECDC4"];
        return {
          name: game.name,
          value: game.count,
          color: colors[index % colors.length]
        };
      });
      
      setPreferredGamesData(transformedData);
    }
  } catch (error) {
    RefreshToken(error, setErrorMessage, setnotification);
    console.error("Error fetching preferred games data:", error);
  }
};

// Function to fetch preferred leagues data
const getPreferredLeaguesData = async () => {
  try {
    const response = await axios.get(`${base_url}/api/dashboard/admin-dashboard/games/`, Config);
    if (response.status === 200) {
      const leaguesData = response.data?.data?.leagues;
      
      // Transform the API response to match your chart format
      const transformedData = leaguesData.map((league, index) => {
        // Define colors for different leagues
        //const colors = ["#3C50E0", "#6E80FF", "#80CAEE", "#0FADCF", "#FF6B6B", "#4ECDC4", "#95A5A6", "#E74C3C"];
        return {
          name: league.short_name, // Use shortName as display name in legend
          fullName: league.name,   // Store full name for tooltip/hover
          shortName: league.short_name,
          value: league.count,
          //color: colors[index % colors.length]
        };
      });
      const dataWithColors = getColorsForChartData(transformedData, 'blue_tones');
      setPreferredLeaguesData(dataWithColors);
    }
  } catch (error) {
    RefreshToken(error, setErrorMessage, setnotification);
    console.error("Error fetching preferred leagues data:", error);
  }
};

// Add this function with your other API functions
// const getAccessLocationData = async (url, filter) => {
//   try {
//     if (filter) {
//       url = url + `?end=${formatDate(filter[0].endDate)}&start=${formatDate(filter[0].startDate)}`;
//     }
//     const response = await axios.get(`${base_url}/api/dashboard/access-locations/`, Config);
    
//     //const response = await axios.get(url, Config);
//     if (response.status === 200) {
//       // Transform the API response to match the BarChart format
//       const transformedData = response.data.data
//         .filter(item => item.country !== null) // Filter out null country names
//         .map(item => ({
//           country: item.country,
//           total_users: item.user_count
//         }));
//       console.log(transformedData, "transformedData")
//       setAccessLocationData(transformedData);
//     }
//   } catch (error) {
//     RefreshToken(error, setErrorMessage, setnotification);
//     console.error("Error fetching access location data:", error);
//   }
// };

//NewChart Function End
  useEffect(() => {
    getDashboradData();
    getCashFlow(`${base_url}/api/dashboard/admin-dashboard/cashflow`,filterData.Cashflow);
    getLeagues(`${base_url}/api/dashboard/admin-dashboard/potdetails`);
    getPopularLeagues(`${base_url}/api/dashboard/admin-dashboard/potdetails`);
    getUserManagement(
      `${base_url}/api/dashboard/admin-dashboard/user-engagement`,filterData.user
    );
    getPlayerDetails(`${base_url}/api/dashboard/admin-dashboard/playersdetail`,filterData.top_players);
    getNonActivePlayerDetails(
      `${base_url}/api/dashboard/admin-dashboard/playersdetail`
    );
    getLocationStatus(`${base_url}/api/dashboard/admin-dashboard/locationuser`);
    getLeaguesData();
     getPreferredGamesData();
  getPreferredLeaguesData();
     getTokenTransferData(`${base_url}/api/dashboard/admin-dashboard/token-chart/`, filterData.token_transfer);
     // Add this call in your useEffect
//getAccessLocationData(`${base_url}/api/dashboard/access-locations/`);
    // getNonActivePlayer();
  }, [filterData]);

  const barChart = [
    { name: "1 months", value: 10 },
    { name: "3 months", value: 10 },
    { name: "6 months", value: 12 },
    { name: "1 year", value: 120 },
  ];

  return (
    <Box>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography
          sx={{
            fontSize: "24px",
            paddingTop: 4,
            paddingBottom: 4,
            fontWeight: "bold",
          }}
        >
          Dashboard
        </Typography>
        {/* <Box sx={{ display: "flex" }}>
          <DateFilter />
        </Box> */}
      </Stack>

      <Box
        sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 4 }}
      >
        <CardComponent
          img={dash1}
          amount={dashborad?.active_users ? dashborad?.active_users : 0}
          text={"Total Playing Players"}
        />
        <CardComponent
          img={dash2}
          amount={dashborad?.total_users ? dashborad?.total_users : 0}
          text={"Total Registered Players"}
        />
        <CardComponent
          img={dash3}
          amount={dashborad?.active_pots ? dashborad?.active_pots : 0}
          text={"Active Rounds"}
        />
        <CardComponent
          img={dash4}
          amount={`USD ${currencyformater(
            dashborad?.payouts ? dashborad?.payouts : 0
          )}`}
          text={"Pending Payouts"}
        />
        <CardComponent
          img={dash5}
          amount={`USD ${currencyformater(
            dashborad?.contributions ? dashborad?.contributions : 0
          )}`}
          text={"Total Contribution"}
        />
        <CardComponent
          img={dash6}
          amount={`USD ${currencyformater(
            dashborad?.commisions ? dashborad?.commisions : 0
          )}`}
          text={"Total Admin Fee"}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          marginTop: 5,
          gap: 3,
        }}
      >
        <CustomLineChart
          xAxisLabel="Date"
          yAxisLabel="Value"
          data={CashflowData}
          title={"Cashflow"}
          filters={"date"}
          setfilterData={setfilterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/cashflow`}
          setData={setCashflowData}
          filterData={filterData}
          filterkey={"Cashflow"}
          align={"left"}
          getFunction={getCashFlow}
          options={[]}
          downloadUrl={{
            commisions: `${base_url}/api/dashboard/admin-dashboard/report?action=admin_commission_report&fields=current_pot_value,admin_fee,admin_commission,id`,
            contributions: `${base_url}/api/dashboard/admin-dashboard/report?action=purchases_report&fields=player__username,amount,created_at__date,token`,
            payouts: `${base_url}/api/dashboard/admin-dashboard/report?action=pay_outs_report&fields=amount_payable,payment_status,player__username,id`,
          }}
        />
       
        <Barchart
          title={"Location Status"}
          data={LocationStatus}
          filters={"date"}
          align={"right"}
          filterkey={"location"}
          getFunction={getLocationStatus}
          setfilterData={setfilterData}
          filterData={filterData}
          options={[]}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=location_users&fields=country,total_users,total_contribution`}
          type={"location"}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/locationuser`}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          marginTop: 3,
          gap: 3,
        }}
      >
        <CustomPieChart
          title={"User Engagement:"}
          filterkey={"user"}
          align={"left"}
          data={userChart}
          filters={"date"}
          setfilterData={setfilterData}
          filterData={filterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/user-engagement`}
          setData={setCashflowData}
          getFunction={getUserManagement}
          options={[]}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=user_engagement&fields=username,first_name,last_name,available_tokens,email,mobile_number,date_joined__date,last_played,last_login__date,status`}
        />

        <Barchart
          title={"Popular Leagues:"}
          filterkey={"leagues"}
          align={"right"}
          data={leagues}
          type={"league"}
          setfilterData={setfilterData}
          filterData={filterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/potdetails`}
          getFunction={getPopularLeagues}
          options={[]}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=league_details&fields=league_name,total_rounds,total_round_value,total_admin_fee,total_picks,status`}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          marginTop: 3,
          gap: 3,
        }}
      >
        <CustomPieChart
          title={"Round Status"}
          filterkey={"leagues"}
          align={"left"}
          data={roundChart}
          filters={"league"}
          setfilterData={setfilterData}
          options={leagueFilter}
          filterData={filterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/potdetails`}
          getFunction={getLeagues}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=pot_details&fields=id,league,round_value,admin_fee,start_date,completed_date,total_picks,active_picks,total_winners,status`}
        />
        <Barchart
          title={"Top Players"}
          filterkey={"top_players"}
          align={"right"}
          data={PlayerTop}
          type={"top_players"}
          filters={"date"}
          setfilterData={setfilterData}
          filterData={filterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/playersdetail`}
          getFunction={getPlayerDetails}
          options={[]}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=top_players&fields=username,firstname,lastname,email,mobile_number,total_picks,available_tokens,total_spent`}
        />
      </Box>
      
      <Box
        sx={{
          display: "flex",
          marginTop: 3,
          gap: 3,
        }}
      >
        <Barchart
          title={"Non-Active Player"}
          filterkey={"non_active"}
          align={"left"}
          data={NonActive}
          type={"in_active"}
          setfilterData={setfilterData}
          filterData={filterData}
          getUrl={`${base_url}/api/dashboard/admin-dashboard/playersdetail`}
          getFunction={getPlayerDetails}
          options={[]}
          downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=inactive_users_report&fields=username,first_name,last_name,email,mobile_number,available_tokens,total_picks,won_picks,last_played_date,inactive_period`}
        />
        <CustomPieChart
  title={"Preferred Sports"}
  filterkey={"preferred_games"}
  align={"right"}
  data={preferredGamesData}
  filters={null}
  setfilterData={setfilterData}
  filterData={filterData}
  getUrl={`${base_url}/api/dashboard/admin-dashboard/games/`}
  setData={setPreferredGamesData}
  getFunction={getPreferredGamesData} // Updated function
  options={[]}
  downloadUrl={`${base_url}/api/dashboard/admin-dashboard/user-preferences?type=games`}
  showDropdown={false}
/>
          {/* <CustomPieChart
    title={"Preferred Games"}
    filterkey={"preferred_games"}
    align={"right"}
    data={preferredGamesData}
    filters={null} // No date filter for this chart
    setfilterData={setfilterData}
    filterData={filterData}
    getUrl={`${base_url}/api/dashboard/admin-dashboard/preferred-games`} // Future API endpoint
    setData={setPreferredGamesData}
    getFunction={getDummyPreferredGames}
    options={[]}
    downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=preferred_games&fields=game_name,user_count,engagement_rate`}
    showDropdown={false}
  /> */}
        
      </Box>
      <Box
        sx={{
          display: "flex",
          marginTop: 3,
          gap: 3,
        }}
      >
      <CustomPieChart
  title={"Preferred Leagues"}
  filterkey={"preferred_leagues"}
  align={"left"}
  data={preferredLeaguesData}
  filters={null}
  setfilterData={setfilterData}
  filterData={filterData}
  getUrl={`${base_url}/api/dashboard/admin-dashboard/games/`} // Note: corrected typo if needed
  setData={setPreferredLeaguesData}
  getFunction={getPreferredLeaguesData} // Updated function
  options={[]}
  downloadUrl={`${base_url}/api/dashboard/admin-dashboard/user-preferences?type=leagues`}
  showDropdown={false}
  selectedFilter={selectedLeagueFilter}
  setSelectedFilter={setSelectedLeagueFilter}
  dropdownOptions={[
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Popular", label: "Popular" }
  ]}
  isPreferredLeagues={true}
/>
       {/* <CustomPieChart
    title={"Preferred Leagues"}
    filterkey={"preferred_leagues"}
    align={"left"}
    data={preferredLeaguesData}
    filters={null} // No date filter for this chart
    setfilterData={setfilterData}
    filterData={filterData}
    getUrl={`${base_url}/api/dashboard/admin-dashboard/preferred-leagues`} // Future API endpoint
    setData={setPreferredLeaguesData}
    getFunction={getDummyPreferredLeagues}
    options={[]}
    downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=preferred_leagues&fields=league_name,user_count,engagement_rate`}
    showDropdown={true}
    selectedFilter={selectedLeagueFilter}
    setSelectedFilter={setSelectedLeagueFilter}
    dropdownOptions={[
      { value: "All", label: "All" },
      { value: "Active", label: "Active" },
      { value: "Popular", label: "Popular" }
    ]}
  /> */}
         {/* <TokenTransferChart
    title="Token Transfer"
    filterkey="token_transfer"
    align="left"
    data={tokenTransferData}
    filters="date"
    setfilterData={setfilterData}
    filterData={filterData}
    getUrl={`${base_url}/api/dashboard/admin-dashboard/token-transfer`}
    getFunction={getTokenTransferData}
    options={[]}
    downloadUrl={`${base_url}/api/dashboard/admin-dashboard/report?action=token_transfer_report&fields=period,transfers,amount,date`}
  /> */}
    <Barchart
    title={"Token Transfer"}
    filterkey={"token_transfer"}
    align={"right"}
    data={tokenTransferData}
    type={"token_transfer"}
    filters={null}
    setfilterData={setfilterData}
    filterData={filterData}
    getUrl={`${base_url}/api/dashboard/admin-dashboard/token-chart/`}
    getFunction={getTokenTransferData}
    options={[]}
    downloadUrl={`${base_url}/api/dashboard/token-transfer/export/`}
  />
      </Box>
      <Box
  sx={{
    display: "flex",
    marginTop: 3,
    gap: 3,
  }}
>
  
</Box>
      <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />
    </Box>
  );
}

// import { Box } from '@mui/material'
// import React from 'react'

// export default function Dashboard() {
//   return (
//     <Box> Dashboard is under construction!</Box>
//   )
// }
